export default {
  authToken: null,
  isAuthenticated: false,
};
